



























import {Component, Vue, Inject, Provide, Prop} from "vue-property-decorator";
import Antd from "ant-design-vue";
import AbpBase from "@/lib/abpbase";
import _ from "lodash";
import UserLayout from "@/layouts/UserLayout.vue";
import loginForm from "@/views/login/loginForm.vue";
import registerForm from "@/views/login/registerForm.vue";
import userDetailForm from "@/views/login/userDetailForm.vue";
import changePassForm from "@/views/login/changePassForm.vue";
import QRLoginForm from "@/views/login/QRLoginForm.vue";
import {API_GetSmsCaptcha} from "@/api/login";
import WxRegister from "@/views/login/wxRegister.vue";
import WxMessage from "@/views/login/wxMessage.vue";

enum LoinState {
    LOGIN = 0,
    RESITER,
    FILLUSERINFO,
    CHANGEPASS,
    QRLOGIN,
    WXMSGCODE,
    WXREGISTER,
}


const TITLE_NAME = {
    0:'登录',
    1:'注册',
    2:'完善个人信息',
    3:'修改密码',
    4:'',
    5:'完善手机信息',
    6:'完善个人信息'
}


@Component({
    components: {
        WxMessage,
        WxRegister,
        UserLayout, loginForm, registerForm,userDetailForm,changePassForm,QRLoginForm}
})
export default class loginIndex extends AbpBase {
    @Prop({type:String,default:''}) isWx:string;

    logStat = LoinState;
    curState = this.logStat.LOGIN;

    provideInfo = {
        uuid:'',
        mobile:'',
    };

    onRegister() {
        this.curState = this.logStat.RESITER;
    }

    //填充
    onFill(e){
        this.provideInfo = {...e}
        this.curState = this.logStat.FILLUSERINFO;
    }

    onRegisterEnd(e){
        this.provideInfo.uuid = '';
        this.curState = this.logStat.LOGIN;
    }

    onChangePass(){
        this.curState = this.logStat.CHANGEPASS;
    }

    onWxMessage(e){
        this.provideInfo = {...e}
        this.curState = this.logStat.WXREGISTER;
    }

    openQRCode(){
        this.curState = this.logStat.QRLOGIN;
    }

    backHome(){
        this.curState = this.logStat.LOGIN;
    }


    get titleName() {
        return TITLE_NAME[this.curState];
    }


    mounted(){
        if(this.isWx){
            this.curState = this.logStat.WXMSGCODE;
        }
    }

}
